import React from "react";
import { FaComment, FaRegThumbsUp } from "react-icons/fa";
import { RxDotsVertical } from "react-icons/rx";
import { PiCursorClickThin, PiCursorThin } from "react-icons/pi";
import { FaShare } from "react-icons/fa";
import { ProfilePicture } from "./CommonComponents";
import RichTextEditor from "@mantine/rte";
import getAvatarUrl from "../utils/dicebear";
function PostComponent({
  id,
  name,
  role,
  ago,
  projectDeck,
  profilePic,
  post,
  likes,
  comments,
  containsImage,
  image,
  title,
  user_id,
}) {
  const editorStyles = {
    root: {
      "& .mantine-RichTextEditor-content": {
        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
        fontSize: "1rem",
        lineHeight: "1.6",
        color: "#374151",
      },
      "& h1": {
        fontSize: "1.875rem",
        fontWeight: "700",
        marginBottom: "1rem",
      },
      "& h2": {
        fontSize: "1.5rem",
        fontWeight: "600",
        marginBottom: "0.875rem",
      },
      "& p": {
        marginBottom: "0.75rem",
      },
      "& ul, & ol": {
        paddingLeft: "1.5rem",
      },
      "& li": {
        marginBottom: "0.375rem",
      },
      "& a": {
        color: "#2563eb",
        textDecoration: "underline",
      },
    },
  };

  return (
    <div className="post p-4 bg-white shadow rounded-lg mb-4 border border-gray-200 lg:max-w-2xl lg:mx-auto">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center">
          <ProfilePicture
            src={getAvatarUrl(name)}
            size={60}
            styles={"mr-4 cursor-pointer"}
            profileUrl={`/profile/${user_id}`}
          />
          <div>
            <h3 className="font-semibold text-sm">{name}</h3>
            <p className="text-xs text-gray-500">{role}</p>
            <p className="text-xs text-gray-400">{ago}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {role && role == "Startup Founder" && (
            <a
              href={projectDeck}
              className="text-xs bg-orange-100 text-orange-600 px-2 py-1 rounded-lg flex items-center gap-1"
            >
              <div className="cursor-container">
                <PiCursorThin
                  className="cursor-icon cursor-default"
                  size={12}
                />
                <PiCursorClickThin
                  className="cursor-icon cursor-click"
                  size={12}
                />
              </div>
              Project Deck
            </a>
          )}
          <RxDotsVertical className="text-gray-600 cursor-pointer" size={22} />
        </div>
      </div>

      {title && <h2 className="text-xl font-bold mb-2">{title}</h2>}

      <div className="post-content mb-4">
        <RichTextEditor value={post} readOnly={true} styles={editorStyles} />
      </div>

      <div className="flex justify-around border-t border-gray-200 pt-2 mt-2">
        <button className="flex items-center text-gray-600 hover:text-blue-600">
          <FaRegThumbsUp className="mr-1" />
          <span className="text-xs">Like ({likes})</span>
        </button>
        <button className="flex items-center text-gray-600 hover:text-blue-600">
          <FaComment className="mr-1" />
          <span className="text-xs">Comment ({comments})</span>
        </button>
        <button className="flex items-center text-gray-600 hover:text-blue-600">
          <FaShare className="mr-1" />
          <span className="text-xs">Share</span>
        </button>
      </div>
    </div>
  );
}
export default PostComponent;
